import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'he',
    supportedLngs: ['he', 'en'],
    debug: false, // ביטול לוגים בדיבאג
    // debug: process.env.NODE_ENV === 'development',
    detection: {
      // הגדרות לגילוי השפה
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'em', 'i', 'b', 'p'],
    },
    backend: {
      loadPath: '/{{lng}}.json',
    },
  });

export default i18n;
